import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Pacientes from "@/pages/admin/Pacientes";
import { pageHead } from "@/lib/seo";

const busca = z.object({
  status: z.enum(["todos", "active", "lead", "paused", "completed", "churned"]).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  ordem: z.enum(["retorno", "nome", "atividade"]).optional().catch(undefined),
  novo: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute("/admin/pacientes/")({
  validateSearch: busca,
  head: () => pageHead({ title: "Pacientes | Painel", path: "/admin/pacientes", noindex: true }),
  component: Pacientes,
});
